define("shared/utils/is-async-relation", ["exports", "@ember-data/model"], function (_exports, _model) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _exports.isAsyncRelation = isAsyncRelation;
  0; //eaimeta@70e063a35619d71f0,"@ember-data/model"eaimeta@70e063a35619d71f

  function isAsyncRelation(model) {
    return typeof model.promise !== 'undefined' && model.content instanceof _model.default;
  }

  var _default = {
    isAsyncRelation
  };
  _exports.default = _default;
});